import axios from "axios";

// const API_BASE_URL = "http://localhost:8090/api/v1";
// const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const API_BASE_URL = "https://qa-backend-nurallite.nuralservice.com/api/v1";

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    console.log("token", token);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Check if error response status is 401
    console.log("error", error.status);
    if (error.status == 401) {
      // Clear token from localStorage if it exists
      localStorage.removeItem("token");

      // Navigate to root path
      window.location.href = "/";
    }

    // Log error and reject promise
    console.error("API Error:", error);
    return Promise.reject(error);
  }
);

// --------------------------------LogIn  API ----------------------------------------------------------
export const logInAPICall = async (data) => {
  try {
    console.log(`this is login api`);
    console.log(`jsonbody is `, data);
    const jsonBody = JSON.stringify(data);
    const response = await api.post("login", jsonBody);
    return response.data;
  } catch (error) {
    console.error("Error logging in API:", error);
    throw error;
  }
};

// --------------------------------Manage Country API ----------------------------------------------------------

export const createCountry = async (data) => {
  try {
    const jsonBody = JSON.stringify(data);
    const response = await api.post("/country", jsonBody);
    return response.data;
  } catch (error) {
    console.error("Error creating country API:", error);
    throw error;
  }
};
export const getCountryListActive = async (search, page, limit, status) => {
  try {
    const queryParams = { search, page, limit, status };
    const response = await api.get("/countries", {
      params: queryParams,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching countries API:", error);
    throw error;
  }
};

export const getCountryListDrop = async (params = {}) => {
  try {
    const response = await api.get(`/countries`, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching country list:", error);
    throw error;
  }
};

export const getCountryList = async (body = {}) => {
  try {
    const queryString =
      body && Object.keys(body).length > 0
        ? `?${new URLSearchParams(body).toString()}`
        : "";
    const response = await api.get(`/countries${queryString}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching countries API:", error);
    throw error;
  }
};

export const fetchCountryDropdown = async (params = {}) => {
  try {
    const finalParams = {
      callType: 1,   // ✅ default
      ...params      // ✅ override if passed
    };

    const response = await api.get("/country/dropdown", { params: finalParams });
    return response.data;
  } catch (error) {
    console.error("Error fetching countries API:", error);
    throw error;
  }
};
export const updateCountry = async (data) => {
  try {
    const jsonBody = JSON.stringify(data);
    const response = await api.put("/country", jsonBody);
    return response.data;
  } catch (error) {
    console.log(`Error updating country ${error}`);
    throw error;
  }
};

export const updateCountryStatus = async (body) => {
  try {
    // const jsonBody = JSON.stringify(hsnCode, status);

    const response = await api.post("/country/toggle", body);
    return response.data;
  } catch (error) {
    console.log(`Error updating country status ${error}`);
    throw error;
  }
};

export const exportCountryList = async (params = {}) => {
  try {
    const response = await api.get("/country/export", { params });
    return response.data; // return full JSON
  } catch (error) {
    console.error("Error exporting country list:", error);
    throw error?.response?.data || error;
  }
};
export const getRegionList = async () => {
  try {
    const response = await api.get("/regions");
    return response.data;
  } catch (error) {
    console.error("Error fetching regions API:", error);
    throw error;
  }
};
// ------------------------------Manage Zone --------------------------

export const createZone = async (data) => {
  try {
    const jsonBody = JSON.stringify(data);
    const response = await api.post("/zone", jsonBody);
    return response.data;
  } catch (error) {
    console.error("Error creating country API:", error);
    throw error;
  }
};

export const getZoneList = async (body = {}) => {
  try {
    const queryString =
      body && Object.keys(body).length > 0
        ? `?${new URLSearchParams(body).toString()}`
        : "";

    const response = await api.get(`/zones${queryString}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching zones API:", error);
    throw error;
  }
};

export const getfilteredZoneList = async (page, limit, countryId, status) => {
  try {
    const queryParams = { page, limit, countryId, status };
    const response = await api.get("/zones", {
      params: queryParams,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching zones API:", error);
    throw error;
  }
};

export const updateZoneStatus = async (body) => {
  try {
    // const jsonBody = JSON.stringify(hsnCode, status);

    const response = await api.post("/zone/toggle", body);
    return response.data;
  } catch (error) {
    console.log(`Error updating zone status ${error}`);
    throw error;
  }
};
export const exportZoneList = async (params = {}) => {
  try {
    const response = await api.get("/zones/export", { params });
    return response.data; // return full JSON
  } catch (error) {
    console.error("Error exporting zone list:", error);
    throw error;
  }
};

export const updateZone = async (data) => {
  try {
    const jsonBody = JSON.stringify(data);
    const response = await api.put("/zone", jsonBody);
    return response.data;
  } catch (error) {
    console.log(`Error updating zone ${error}`);
    throw error;
  }
};

// --------------------------------Manage State API ----------------------------------------------------------

export const getStateList = async (
  stateName,
  page,
  limit,
  countryId,
  zoneId,

  status
) => {
  try {
    const queryParams = { stateName, page, limit, countryId, zoneId, status };

    const response = await api.get("/states", {
      params: queryParams,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching states API:", error);
    throw error;
  }
};

export const getStateListDrop = async (params = {}) => {
  try {
    const response = await api.get(`/states`, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching state list:", error);
    throw error;
  }
};

export const getStateList2 = async (
  stateName,
  page,
  limit,
  countryId,
  zoneId
) => {
  try {
    const queryParams = { stateName, page, limit, countryId, zoneId };
    const response = await api.get("/states", {
      params: queryParams,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching states API:", error);
    throw error;
  }
};
export const getStateListsearch = async (countryId, zoneId, status) => {
  try {
    const queryParams = { countryId, zoneId, status };
    const response = await api.get("/states", {
      params: queryParams,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching states API:", error);
    throw error;
  }
};

export const createState = async (data) => {
  try {
    const jsonBody = JSON.stringify(data);
    const response = await api.post("/state", jsonBody);
    return response.data;
  } catch (error) {
    console.error("Error creating state API:", error);
    throw error;
  }
};
export const updateState = async (data) => {
  try {
    const jsonBody = JSON.stringify(data);
    const response = await api.put("/state", jsonBody);
    return response.data;
  } catch (error) {
    console.error("Error creating state API:", error);
    throw error;
  }
};

export const deleteState = async (id) => {
  try {
    const jsonBody = JSON.stringify({
      id: id,
    });
    const response = await api.post("/state/delete", jsonBody);
    return response.data;
  } catch (error) {
    console.log(`Error in deleting state ${error}`);
    throw error;
  }
};

export const updateStateStatus = async (state) => {
  try {
    const jsonBody = JSON.stringify(state);
    const response = await api.post("/state/toggle", jsonBody);
    return response.data;
  } catch (error) {
    console.log(`Error updating state status ${error}`);
    throw error;
  }
};

export const exportStateList = async (params = {}) => {
  try {
    const response = await api.get("/state/export", { params });
    return response.data;
  } catch (error) {
    console.error("Error exporting state list:", error);
    throw error;
  }
};

export const exportJobReport = async (params = {}) => {
  try {
    const response = await api.get("/export-job-report", { params });
    return response.data;
  } catch (error) {
    console.error("Error exporting job report:", error);
    throw error;
  }
};
// --------------------------------Manage District API ----------------------------------------------------------
export const getDistrictList = async () => {
  try {
    const response = await api.get("/districts");
    return response.data;
  } catch (error) {
    console.error("Error fetching districts API:", error);
    throw error;
  }
};

export const deleteDistrictList = async (Id) => {
  try {
    const jsonBody = JSON.stringify({
      id: Id,
    });
    console.log(jsonBody);
    const response = await api.post(`/district/delete`, jsonBody);
    console.log(response.data);
    return response.data;
  } catch (error) {
    console.error("Error deleting district API:", error);
    throw error;
  }
};

export const createDistrict = async (data) => {
  try {
    const jsonBody = JSON.stringify(data);
    const response = await api.post("/district", jsonBody);
    return response.data;
  } catch (error) {
    console.error("Error creating district API:", error);
    throw error;
  }
};

// --------------------------------Manage City API ----------------------------------------------------------

export const getCityList = async (
  countryId,
  zoneId,
  stateId,
  page,
  limit,
  cityName
) => {
  try {
    const queryParams = { countryId, zoneId, stateId, page, limit, cityName };
    const response = await api.get("/cities", { params: queryParams });

    return response.data;
  } catch (error) {
    console.error("Error fetching cities API:", error);
    throw error;
  }
};

export const getCityListDrop = async (params = {}) => {
  try {
    const response = await api.get(`/cities`, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching city list:", error);
    throw error;
  }
};

export const deleteCityList = async (Id) => {
  try {
    const jsonBody = JSON.stringify({
      id: Id,
    });
    console.log(jsonBody);
    const response = await api.post(`/city/delete`, jsonBody);
    console.log(response.data);
    return response.data;
  } catch (error) {
    console.error("Error deleting city API:", error);
    throw error;
  }
};

export const createCity = async (data) => {
  try {
    const jsonBody = JSON.stringify(data);
    const response = await api.post("/city", jsonBody);
    return response.data;
  } catch (error) {
    console.error("Error creating city API:", error);
    throw error;
  }
};

export const updateCity = async (data) => {
  try {
    const jsonBody = JSON.stringify(data);
    const response = await api.put("/city", jsonBody);
    return response.data;
  } catch (error) {
    console.error("Error updating city API:", error);
    throw error;
  }
};

export const updateCityStatus = async (city) => {
  try {
    const jsonBody = JSON.stringify(city);
    const response = await api.post("/city/toggle", jsonBody);
    return response.data;
  } catch (error) {
    console.error("Error updating city status API:", error);
    throw error;
  }
};

export const exportCityList = async (params = {}) => {
  try {
    const response = await api.get("/city/export", { params });
    return response.data; // return full JSON
  } catch (error) {
    console.error("Error exporting city list:", error);
    throw error;
  }
};
// --------------------------------Manage Brand API ----------------------------------------------------------
export const fetchBrandDropdownList = async (page, limit, search) => {
  try {
    const queryParams = { page, limit, search };
    console.log(queryParams);

    const response = await api.get("/brands", {
      params: queryParams,

      //     const response = await api.get("/brands/", {
      //       params: queryParams
    });
    return response.data;
  } catch (error) {
    console.log(`Error fetching brand list ${error}`);
    throw error;
  }
};
export const fetchBrandListDropdown = async (params = {}) => {
  try {
    const response = await api.get("/brands", { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching brand list:", error);
    throw error;
  }
};

export const fetchAllBrandList = async () => {
  try {
    const queryParams = {};
    const response = await api.get("/brands", {
      params: queryParams,
    });
    return response.data;
  } catch (error) {
    console.error(`Error fetching brand list: ${error}`);
    throw error;
  }
};

export const createBrand = async (data) => {
  try {
    const jsonBody = JSON.stringify(data);
    const response = await api.post("/brand", jsonBody);
    return response.data;
  } catch (error) {
    console.log("Error creating brand error", error);
    throw error;
  }
};
export const updateBrand = async (data) => {
  try {
    const jsonBody = JSON.stringify(data);
    console.log(`jsonBody is ${jsonBody}`);
    const response = await api.put("/brand", jsonBody);
    return response.data;
  } catch (error) {
    console.log(`Error updating brand ${error}`);
    throw error;
  }
};
export const updateBrandStatus = async (brand) => {
  try {
    const jsonBody = JSON.stringify(brand);

    const response = await api.post("/brand/toggle", jsonBody);
    return response.data;
  } catch (error) {
    console.log(`Error updating brand status ${error}`);
    throw error;
  }
};

export const deleteBrand = async (brandId) => {
  try {
    const jsonBody = JSON.stringify({ brandId: brandId });
    console.log(jsonBody);
    const response = await api.post("/brand/delete", jsonBody);
    return response.data;
  } catch (error) {
    console.log(`Error deleting brand ${error}`);
    throw error;
  }
};

//---------------------------------Manage Category API ----------------------------------------------------------

export const fetchCategoryList = async (
  brandId,
  categoryName,
  page,
  limit,
  status
) => {
  try {
    const queryParams = { brandId, categoryName, page, limit, status };
    const response = await api.get("/categories", {
      params: queryParams,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching category list:", error);
    throw error;
  }
};

export const fetchCategoryListDropdown = async (brandId) => {
  try {
    const response = await api.get(
      `/categories?brandId=${brandId}&dropdown=true`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching category list:", error);
    throw error;
  }
};

export const fetchCategoryList2 = async (
  brandId,
  categoryName,
  page,
  limit
) => {
  try {
    const queryParams = { brandId, categoryName, page, limit };
    const response = await api.get("/categories", {
      params: queryParams,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching category list:", error);
    throw error;
  }
};
export const fetchAllCategoryList = async (params) => {
  try {
    const response = await api.get("/categories", {
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching category list:", error);
    throw error;
  }
};

export const createCategory = async (category) => {
  try {
    const jsonBody = JSON.stringify(category);
    const response = await api.post("/category", jsonBody);
    return response.data;
  } catch (error) {
    console.log(`Error creating category ${error}`);
    throw error;
  }
};

export const updateCategory = async (data) => {
  try {
    const jsonBody = JSON.stringify(data);
    const response = await api.put("/category", jsonBody);
    return response.data;
  } catch (error) {
    console.log(`Error updating category ${error}`);
    throw error;
  }
};

export const updateCategoryStatus = async (category) => {
  try {
    const jsonBody = JSON.stringify(category);
    const response = await api.post("/category/toggle", jsonBody);
    return response.data;
  } catch (error) {
    console.log(`Error updating category status ${error}`);
    throw error;
  }
};

export const deleteCategory = async (categoryId) => {
  try {
    const jsonBody = JSON.stringify({ categoryId: categoryId });
    const response = await api.post("/category/delete", jsonBody);
    return response.data;
  } catch (error) {
    console.log(`Error deleting category ${error}`);
    throw error;
  }
};

// --------------------------------Manage SubCategory API ----------------------------------------------------------

export const fetchSubCategoryList = async (
  subcategoryName,
  page,
  limit,
  brandId,
  categoryId
) => {
  try {
    const queryParams = { subcategoryName, page, limit, brandId, categoryId };
    const response = await api.get("/subcategories", {
      params: queryParams,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching subcategory list:", error);
    throw error;
  }
};
export const fetchSubCategoryListActive = async (
  subcategoryName,
  page,
  limit,
  brandId,
  categoryId,
  status
) => {
  try {
    const queryParams = {
      subcategoryName,
      page,
      limit,
      brandId,
      categoryId,

      status,
    };
    const response = await api.get("/subcategories", {
      params: queryParams,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching subcategory list:", error);
    throw error;
  }
};

export const fetchSubCategoryListDropdown = async (params = {}) => {
  try {
    const response = await api.get(`/subcategories`, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching subcategory list:", error);
    throw error;
  }
};

export const createSubCategory = async (subCategory) => {
  try {
    const jsonBody = JSON.stringify(subCategory);
    const response = await api.post("/subcategory", jsonBody);
    return response.data;
  } catch (error) {
    console.log(`Error creating subcategory ${error}`);
    throw error;
  }
};

export const updateSubCategory = async (data) => {
  try {
    const jsonBody = JSON.stringify(data);
    console.log("jsonBody", jsonBody);
    const response = await api.put("/subcategory", jsonBody);
    return response.data;
  } catch (error) {
    console.log(`Error updating subcategory ${error}`);
    throw error;
  }
};

export const updateSubCategoryStatus = async (subcategoryId) => {
  try {
    const jsonBody = JSON.stringify(subcategoryId);
    const response = await api.post("/subcategory/toggle", jsonBody);
    return response.data;
  } catch (error) {
    console.log(`Error updating subcategory status ${error}`);
    throw error;
  }
};

export const fetchSubCategoryDropdown = async (params) => {
  try {
    const response = await api.get(`/subcategory/dropdown`, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching subcategory list:", error);
    throw error;
  }
};

export const exportSubCategory = async (params) => {
  try {
    const response = await api.get(`/subcategory/export`, {
      params,
    });
    return response.data;
  } catch (error) {
    console.error(`Error exporting subcategory list: ${error}`);
    throw error;
  }
};

// --------------------------------Manage Model API ----------------------------------------------------------

export const fetchModelList = async (params) => {
  try {
    console.log("params", params);
    const response = await api.get("/models", {
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching model list:", error);
    throw error;
  }
};

export const fetchModelListActive = async (
  modelName,
  page,
  limit,
  brandId,
  categoryId,
  subcategoryId
) => {
  // export const fetchSubCategoryList = async () => {

  try {
    const queryParams = {
      modelName,
      page,
      limit,
      brandId,
      categoryId,
      subcategoryId,
    };
    const response = await api.get("/models", {
      params: queryParams,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching model list:", error);
    throw error;
  }
};

export const importModel = async (body) => {
  try {
    const response = await api.post("/model/import", body, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error importing models API:", error);
    throw error;
  }
};

export const exportModel = async (params) => {
  try {
    const response = await api.get(`/model/export`, {
      params,
    });
    return response.data;
  } catch (error) {
    console.error(`Error exporting model list: ${error}`);
    throw error;
  }
};

export const downloadModelReferenceCode = async () => {
  try {
    const response = await api.get(`/model/reference-code/download`);
    return response.data;
  } catch (error) {
    console.error(`Error downloading model reference code: ${error}`);
    throw error;
  }
};

export const downloadSparePartReferenceCode = async () => {
  try {
    const response = await api.get(`/spare-part/reference-code/download`);
    return response.data;
  } catch (error) {
    console.error(`Error downloading spare part reference code: ${error}`);
    throw error;
  }
};

export const downloadModelSparePartMappingReferenceCode = async (params) => {
  try {
    const response = await api.get(`/model-spare-part-mapping/reference-code/download`, { params });
    return response.data;
  } catch (error) {
    console.error(`Error downloading model spare part mapping reference code: ${error}`);
    throw error;
  }
};

export const downloadStockGRNReferenceCode = async (params) => {
  try {
    const response = await api.get(`/stock-grn/reference-code/download`, { params });
    return response.data;
  } catch (error) {
    console.error(`Error downloading stock GRN reference code: ${error}`);
    throw error;
  }
};

export const downloadTransferStockReferenceCode = async (params) => {
  try {
    const response = await api.get(`/stock-transfer/reference-code/download`, { params });
    return response.data;
  } catch (error) {
    console.error(`Error downloading stock transfer reference code: ${error}`);
    throw error;
  }
};

export const createModel = async (model) => {
  try {
    const jsonBody = JSON.stringify(model);
    const response = await api.post("/model", jsonBody);
    return response.data;
  } catch (error) {
    console.log(`Error creating model ${error}`);

    throw error;
  }
};

export const updateModel = async (data) => {
  try {
    const jsonBody = JSON.stringify(data);
    const response = await api.put("/model", jsonBody);
    return response.data;
  } catch (error) {
    console.log(`Error updating model ${error}`);

    throw error;
  }
};

export const updateModelStatus = async (model) => {
  try {
    const jsonBody = JSON.stringify(model);
    const response = await api.post("/model/toggle", jsonBody);
    return response.data;
  } catch (error) {
    console.log(`Error updating model status ${error}`);
    throw error;
  }
};

// export const updateModel = async (data) => {
//   try {
//     const jsonBody = JSON.stringify(data);
//     const response = await api.put("/model", jsonBody);
//     return response.data;
//   } catch (error) {
//     console.log(`Error updating model ${error}`);
//     throw error;
//   }
// };

// export const updateModelStatus = async (model) => {
//   try {
//     const jsonBody = JSON.stringify(model);
//     const response = await api.post("/model/toggle", jsonBody);
//     return response.data;
//   } catch (error) {
//     console.log(`Error updating model status ${error}`);
//     throw error;
//   }
// };

// --------------------------------TAX API ----------------------------------------------------------

export const createTax = async (data) => {
  try {
    const jsonBody = JSON.stringify(data);
    const response = await api.post("/tax", jsonBody);
    return response.data;
  } catch (error) {
    console.log(`Error creating brand ${error}`);
    throw error;
  }
};

export const updateTax = async (data) => {
  try {
    const jsonBody = JSON.stringify(data);
    const response = await api.put("/tax", jsonBody);
    return response.data;
  } catch (error) {
    console.log(`Error updaing tax ${error}`);
    throw error;
  }
};

export const getTaxes = async (search = "", page = 1, limit = 10) => {
  try {
    const response = await api.get("/taxes", {
      params: { search, page, limit },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching taxes:", error);
    throw error;
  }
};

export const filterHsnCode = async (hsnCode = "", page = 1, limit = 10) => {
  try {
    const response = await api.get("/taxes/hsnCode", {
      params: { hsnCode, page, limit },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching taxes:", error);
    throw error;
  }
};

export const updateTaxStatus = async (body) => {
  try {
    // const jsonBody = JSON.stringify(hsnCode, status);

    const response = await api.post("/tax-status", body);
    return response.data;
  } catch (error) {
    console.log(`Error updating tax status ${error}`);
    throw error;
  }
};

export const deleteTax = async (taxId) => {
  try {
    const response = await api.post(`/taxes/delete/${taxId}`);
    return response.data;
  } catch (error) {
    console.log(`Error deleting tax ${error}`);
    throw error;
  }
};

export const exportTax = async (params = {}) => {
  try {
    const response = await api.get("/tax/export", { params });
    return response.data; // return full JSON
  } catch (error) {
    console.log(`Error exporting tax ${error}`);
    throw error;
  }
};
// --------------------------------tax master ends here API ----------------------------------------------------------
// --------------------------------Manage Customer API ----------------------------------------------------------
export const customers = async (queryParams) => {
  try {
    const response = await api.get(`/customers`, { params: queryParams });
    console.log("response==", response);
    return response.data;
  } catch (error) {
    console.log(`Error getting customer: ${error}`);
    throw error;
  }
};

// export const customersById = async (customerId) => {
//   try {
//     // Ensure customerId is correctly passed as part of the URL
//     const response = await api.get(`/customer/details/${customerId}`);
//     console.log("response==", response);
//     return response.data;
//   } catch (error) {
//     console.log(`Error getting customer by id: ${error}`);
//     throw error;
//   }
// };

export const customersById = async (customerId) => {
  try {
    if (typeof customerId !== "string") {
      throw new Error("Invalid customerId provided. It must be a string.");
    }

    const response = await api.get(`/customer/details/${customerId}`);
    console.log("response==", response);
    return response.data;
  } catch (error) {
    console.error(`Error getting customer: ${error}`);
    throw error;
  }
};

export const customerProduct = async (queryParams) => {
  try {
    const response = await api.get(`/products`, { params: queryParams });
    return response.data;
  } catch (error) {
    console.error(`Error getting customer's products: ${error}`);
    throw error;
  }
};

export const addProduct = async (formData) => {
  try {
    const response = await api.post("/product", formData, {
      // headers: { "Content-Type": "multipart/form-data" },
      headers: { "Content-Type": "application/json" },
    });
    return response.data;
  } catch (error) {
    console.error("Error adding product:", error);
    throw error;
  }
};

export const changePassword = async (data) => {
  try {
    const response = await api.post(`/change-password`, data);
    console.log("response", response);
    return response.data;
  } catch (error) {
    console.error(`Error changing password: ${error}`);
    throw error;
  }
};

export const forgotPassword = async (data) => {
  try {
    const response = await api.post(`/forget-password`, data);
    return response.data;
  } catch (error) {
    console.error(`Error in forgot password: ${error}`);
    throw error;
  }
};

export const userByEntityId = async ({ entityType }) => {
  try {
    console.log("entityType:", entityType); // Debugging

    // Construct the URL dynamically
    const response = await api.get(`/user/${entityType}`);

    return response.data;
  } catch (error) {
    console.error(`Error in userByEntityId: ${error.message}`); // More detailed error
    throw error;
  }
};
export const changeAdminPassword = async (data) => {
  try {
    const response = await api.post(`/admin-change-password`, data);
    return response.data;
  } catch (error) {
    console.error(`Error in changeAdminPassword: ${error}`);
    throw error;
  }
};

//----------------------------------Manage Spare Part -------------------------------------------------------//

export const fetchSparePartList = async (params = {}) => {
  try {
    console.log("queryParams", params);

    const response = await api.get("/spare-parts", {
      params,
    });

    return response.data;
  } catch (error) {
    console.log(`Error fetching spare part list: ${error}`);
    throw error;
  }
};

export const sparePartDropdown = async (params = {}) => {
  try {
    console.log("queryParams", params);

    const response = await api.get("/spare-part/dropdown", {
      params,
    });

    return response.data;
  } catch (error) {
    console.log(`Error fetching spare part list: ${error}`);
    throw error;
  }
};

export const fetchSparePartList2 = async () => {
  try {
    const response = await api.get("/spare-parts");
    return response.data;
  } catch (error) {
    console.log(`Error fetching spare part list: ${error}`);
    throw error;
  }
};

export const createSparePart = async (data) => {
  try {
    const jsonBody = JSON.stringify(data);
    const response = await api.post("/spare-part", jsonBody);
    return response.data;
  } catch (error) {
    console.log("Error creating spare part error", error);
    throw error;
  }
};

export const updateSparePart = async (data) => {
  try {
    const jsonBody = JSON.stringify(data);
    console.log(`jsonBody is ${jsonBody}`);
    const response = await api.put("/spare-part", jsonBody);
    return response.data;
  } catch (error) {
    console.log(`Error updating spare part ${error}`);
    throw error;
  }
};

export const updateSparePartStatus = async (sparePartId) => {
  try {
    const jsonBody = JSON.stringify(sparePartId);

    const response = await api.post("/spare-part-status", jsonBody);
    return response.data;
  } catch (error) {
    console.log(`Error updating spare part status ${error}`);
    throw error;
  }
};

// ----------------------------------------------------Manage Spare Part mapping --------------------------------------------//

export const mapSparePartToModel = async (data) => {
  try {
    const jsonBody = JSON.stringify(data);
    const response = await api.post("/spare-part/model", jsonBody);
    return response.data;
  } catch (error) {
    console.log(`Error mapping spare part to model ${error}`);
    throw error;
  }
};

export const getSparePartByModel = async (params) => {
  try {
    const response = await api.get("/model/spare-parts", { params });
    return response.data;
  } catch (error) {
    console.log(`Error in getting spare part by model: ${error}`);
    throw error;
  }
};

export const getSparePartByModelDropdown = async (params) => {
  try {
    const response = await api.get("/model/spare-parts/dropdown", { params });
    return response.data;
  } catch (error) {
    console.log(`Error in getting spare part by model: ${error}`);
    throw error;
  }
};

export const getSparePartByModelToggle = async (id) => {
  try {
    const response = await api.put(`/spare-part/model/toggle-status/${id}`);

    return response.data;
  } catch (error) {
    console.log(`Error in getting status update spare part by model: ${error}`);
    throw error;
  }
};

export const exportSparePartByModel = async (params = {}) => {
  try {
    const response = await api.get("/model-sparepart/export", { params });
    return response.data;
  } catch (error) {
    console.error("Error exporting spare part mapping list:", error);
    throw error;
  }
};

//---------------------------------------------------------user master--------------------------------------------------//

export const createUser = async (data) => {
  try {
    // const jsonBody = JSON.stringify(data);
    const response = await api.post("/user/create", data);
    return response;
  } catch (error) {
    console.log(`Error creating user `, error);
    throw error;
  }
};
export const fetchUserList = async (params) => {
  try {
    const response = await api.get("/users", { params });
    return response;
  } catch (error) {
    console.log(`Error fetching user list: ${error}`);
    throw error;
  }
};
//---------------------------------------------------AMC Master -------------------------------------------------------//

export const fetchAmcMaster = async (filters) => {
  try {
    const response = await api.get("/amcs", { params: filters });
    return response.data;
  } catch (error) {
    console.log(`Error in fetching AMC master: ${error}`);
    throw error;
  }
};

export const createAmcMaster = async (data) => {
  try {
    const jsonBody = JSON.stringify(data);
    const response = await api.post("/amc", jsonBody);
    return response.data;
  } catch (error) {
    console.log(`Error in creating amc master ${error}`);
    throw error;
  }
};
export const amcStatusUpdate = async (data) => {
  try {
    const jsonBody = JSON.stringify(data);
    const response = await api.post("/amc-status", jsonBody);
    return response.data;
  } catch (error) {
    console.log(`Error in creating amc master ${error}`);
    throw error;
  }
};

export const addAmc = async (data) => {
  try {
    const jsonBody = JSON.stringify(data);
    const response = await api.post("/amc", jsonBody);
    console.log("response in api", response);
    return response.data;
  } catch (error) {
    console.log(`Error in creating amc master ${error}`);
    throw error;
  }
};

export const updateAmc = async (data) => {
  try {
    const jsonBody = JSON.stringify(data);
    const response = await api.put("/amc", jsonBody);
    return response.data;
  } catch (error) {
    console.log(`Error in creating amc master ${error}`);
    throw error;
  }
};
export const exportAmc = async (params) => {
  try {
    const response = await api.get(`/amc/export`, {
      params,
    });
    return response.data;
  } catch (error) {
    console.error(`Error exporting AMC: ${error}`);
    throw error;
  }
};

export const getAmcDropdown = async (params = {}) => {
  try {
    const response = await api.get("/amc/dropdown", { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching AMC dropdown:", error);
    throw error;
  }
};

//--------------------------------------------Customers-------------------------------------------------------------------//

export const createCustomers = async (data) => {
  try {
    const response = await api.post("/customer", data);
    return response.data;
  } catch (error) {
    console.log(`Error creating customer ${error}`);
    // Propagate the error to be handled by the component
    throw error;
  }
};

//-----------------------spare part  mapping ---------------------------------------------------------------------------------------
export const getServiceCenterList = async () => {
  try {
    console.log("runnningngnngngngng")
    const response = await api.get("/organization/service-centers");
    console.log("response.datadatadttdtdtstats", response.data)
    return response.data;
  } catch (error) {
    console.error(`Error in getting getServiceCenterList: ${error}`);

    throw error;
  }
};

export const updateCustomers = async (customerId, data) => {
  try {
    const response = await api.put(`/customer/${customerId}`, data);
    return response.data;
  } catch (error) {
    console.error("Error updating customer:", error);
    throw error;
  }
};

export const createCustomerAmc = async (data) => {
  try {
    const response = await api.post("/assign/customer/amc", data);
    return response.data;
  } catch (error) {
    console.error(`Error creating customer AMC: ${error}`);
    throw error;
  }
};

//--------------------------------------------Call Dashboard starts here -------------------------------------------------------------------
export const fetchJobList = async (params) => {
  try {
    console.log(params);
    const response = await api.get("/jobs/amcs", {
      params,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error) {
    console.error(`Error fetching job list: ${error}`);
    throw error;
  }
};

export const logProductComplaint = async (data) => {
  try {
    const response = await api.post("/jobs/amc", data);
    return response.data;
  } catch (error) {
    console.error(`Error creating customer AMC: ${error}`);

    throw error;
  }
};

export const assignEngineer = async (data) => {
  try {
    const response = await api.put("/job/allocate", data);
    return response.data;
  } catch (error) {
    console.error(`Error assigning engineer: ${error}`);
    throw error;
  }
};
export const fetchBrandList = async (params) => {
  try {
    const response = await api.get(`/brands`, { params });
    return response.data;
  } catch (error) {
    console.error(`Error fetching brand list: ${error}`);
    throw error;
  }
};
export const exportBrand = async (params) => {
  try {
    const response = await api.get(`/brand/export`, {
      params,
    });
    return response.data;
  } catch (error) {
    console.error(`Error exporting brand list: ${error}`);
    throw error;
  }
};
export const fetchServieCenterList = async (
  organizationAdminId = "6731ac5331f3986384d72eb4"
) => {
  try {
    const response = await api.get(`/organization/service-centers`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching service center list: ${error}`);
    throw error;
  }
};

export const fetchEngineerList = async (params) => {
  try {
    // Pass `params` as query parameters
    const response = await api.put('/service-center/engineers', {}, { params });
    return response.data;
  } catch (error) {
    console.error(`Error fetching engineers list: ${error}`);
    throw error;
  }
};


export const getServiceCentreList = async () => {
  try {
    const response = await api.get("organization/service-centers");
    return response.data;
  } catch (error) {
    console.log(`Error in getting ServiceCentreList ${error}`);

    throw error;
  }
};

//--------------------------------------------Call Dashboard ends here -------------------------------------------------------------------
//--------------------------------------------Repair Update begins here -------------------------------------------------------------------
export const fetchCategory = async (params) => {
  try {
    const response = await api.get(`/categories?${params}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching category list: ${error}`);
    throw error;
  }
};

export const fetchSubCategory = async (params) => {
  try {
    const response = await api.get(`/subcategories?${params}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching subcategory list: ${error}`);
    throw error;
  }
};

export const exportCategory = async (params) => {
  try {
    const response = await api.get(`/category/export`, {
      params,
    });
    return response.data;
  } catch (error) {
    console.error(`Error exporting subcategory list: ${error}`);
    throw error;
  }
};
export const importSparePartMapping = async (formData) => {
  try {
    const response = await api.post("/spare-part-mapping/import", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error importing spare part mapping API:", error);
    throw error;
  }
};

export const fetchModel = async (params) => {
  try {
    const response = await api.get(`/models?${params}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching model list: ${error}`);
    throw error;
  }
};

export const fetchPartList = async (params) => {
  try {
    const response = await api.get(`/spare-parts?${params}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching part list: ${error}`);
    throw error;
  }
};

export const importSparePart = async (formData) => {
  try {
    const response = await api.post("/spare-part/import", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error importing spare parts API:", error);
    throw error;
  }
};

export const exportParts = async (params) => {
  try {
    const response = await api.get(`/spare-part/export`, {
      params,
    });
    return response.data;
  } catch (error) {
    console.error(`Error exporting part list: ${error}`);
    throw error;
  }
};

export const fetchJobNumber = async () => {
  try {
    const response = await api.get(`/job/getJobNumberDropdown`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching job number: ${error}`);
    throw error;
  }
};

export const fetchJobStatus = async (params) => {
  try {
    const response = await api.get(`/job/getJobStatusCounts`, { params });
    return response.data;
  } catch (error) {
    console.error(`Error fetching job status counts: ${error}`);
    throw error;
  }
};

export const closeRepairWithPart = async (data) => {
  try {
    const response = await api.put("/job/repairWithPart", data);
    return response;
  } catch (error) {
    console.error(`Error closing repair with part: ${error}`);
    throw error;
  }
};

export const closeWithReplacement = async (data) => {
  try {
    const response = await api.put("/job/replacement-model", data);
    return response;
  } catch (error) {
    console.error(`Error closing repair with replacement: ${error}`);
    throw error;
  }
};

export const closeWithPartPending = async (data) => {
  try {
    const response = await api.put("/job/pending-for-part", data);
    return response;
  } catch (error) {
    console.error(`Error closing repair with part pending: ${error}`);
    throw error;
  }
};

export const closeWithRemarks = async (data) => {
  try {
    const response = await api.put("/job/closed-without-do-any-work", data);
    return response;
  } catch (error) {
    console.error(`Error closing repair with remarks: ${error}`);
    throw error;
  }
};

//--------------------------------------------Repair Update ends here -------------------------------------------------------------------
//--------------------------------------------AMC dashboard begins here -------------------------------------------------------------------
export const fetchAMCList = async (params) => {
  try {
    // Construct query string from params
    const queryString = new URLSearchParams(params).toString();
    console.log(queryString);

    // Use query string in the GET request
    const response = await api.get(`/customer/amcs?${queryString}`);
    return response.data;
  } catch (error) {
    console.error(`Error in fetching AMC list: ${error}`);
    throw error;
  }
};

export const updateAMC = async (data) => {
  try {
    console.log(" i am update AMC");
    const response = await api.put("/editcustomer/amc", data);
    return response.data;
  } catch (error) {
    console.error(`Error in updating AMC: ${error}`);
    throw error;
  }
};

export const fetchAMCSummary = async () => {
  try {
    const response = await api.get("/amc/report");
    return response;
  } catch (error) {
    console.error(`Error in fetching AMC summary: ${error}`);
    throw error;
  }
};
export const exportAmcsList = async (params) => {
  try {
    const response = await api.get("/customer/amcs/export", { params });
    return response.data;
  } catch (error) {
    console.error("Error exporting AMC list:", error);
    throw error;
  }
};

//--------------------------------------------AMC dashboard ends here -------------------------------------------------------------------


export const dropdownSubscription = async () => {
  try {
    const response = await api.get(`/dropdown/subscription`);
    return response;
  } catch (error) {
    console.error(`Error fetching dropdownSubscription : ${error}`);
    throw error;
  }
};

export const createClientOrganization = async (data) => {
  try {
    const response = await api.post("/organization/create", data, {
      headers: {
        // "Content-Type": "multipart/form-data",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error(`Error in creating ClientOrganization: ${error}`);
    throw error;
  }
};

export const getOrganizations = async (params = {}) => {
  try {
    const response = await api.get(`/organizations`, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching organization list:", error);

    throw error;
  }
};
export const fetchModelListDropdown = async (params = {}) => {
  try {
    const response = await api.get(`/models`, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching model list:", error);
    throw error;
  }
};

export const updateOrganization = async (body) => {
  try {
    const response = await api.put("/organization", body);
    return response.data;
  } catch (error) {
    console.error("Error in updating organization:", error);
    throw error;
  }
};

export const upgradeToSubscription = async (body) => {
  try {
    const response = await api.put("/organization/upgradeToSubscription", body);
    return response.data;
  } catch (error) {
    console.error("Error upgrading to subscription:", error);
    throw error;
  }
};

export const fetchSubscriptionList = async (params) => {
  try {
    const response = await api.get(`/superAdmin/getallPackagesdropdown`, {
      params,
    });
    return response.data;
  } catch (error) {
    console.error(`Error fetching subscription list: ${error}`);
    throw error;
  }
};

//--------------------------------------------Manage Package begins here -------------------------------------------------------------------

export const fetchPackage = async (params) => {
  try {
    const response = await api.get(`/superAdmin/getPackages?${params}`);
    return response.data;
  } catch (error) {
    console.error(`Error in creating package: ${error}`);
    throw error;
  }
};

export const getSuperAdminDashboard = async () => {
  try {
    const response = await api.get("/superAdmin/Dashboard");
    return response.data;
  } catch (error) {
    console.error("Error fetching super admin dashboard:", error);
    throw error;
  }
};

export const getSuperAdminTrailsDashboard = async () => {
  try {
    const response = await api.get("/superAdmin/TrailDashboard");
    return response.data;
  } catch (error) {
    console.error("Error fetching super admin dashboard:", error);
    throw error;
  }
};

export const extendTrialApi = async (data) => {
  try {
    console.log("data", data);
    const response = await api.put("/organization/extandTrails", data);
    return response.data;
  } catch (error) {
    console.error("Error extending trial:", error);
    throw error;
  }
};

export const getSuperAdminSubscribeDashboard = async () => {
  try {
    const response = await api.get("/superAdmin/SubscribeDashboard");
    return response.data;
  } catch (error) {
    console.error("Error fetching super admin subscribe dashboard:", error);
    throw error;
  }
};

// export const createPackage = async (data) => {
//   try {
//     const response = await api.post(`/superAdmin/getPackages`, data);
//     return response.data;
//   } catch (error) {
//     console.error(`Error in creating package: ${error}`);
//     throw error;
//   }
// };

//--------------------------------------------Manage Package ends here -------------------------------------------------------------------
//--------------------------------------------Geography Upload begins here -------------------------------------------------------------------

export const uploadGeography = async (body) => {
  try {
    console.log("body", body);
    const response = await api.post("/geography/import", body, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error) {
    console.error(`Error in uploading geography: ${error}`);
    throw error;
  }
};

export const downloadGeographyReference = async () => {
  try {
    const response = await api.get("/city/export", {
      responseType: "blob", // Ensures the response is a file (binary data)
    });
    return response.data;
  } catch (error) {
    console.error("Error downloading geography reference:", error);
    throw error;
  }
};

export const downloadGeographyTemplate = async () => {
  try {
    const response = await api.get("/geography/template");
    return response.data;
  } catch (error) {
    console.error("Error downloading geography template:", error);
    throw error;
  }
};
//--------------------------------------------Geography Upload ends here -------------------------------------------------------------------
//--------------------------------------------Module begins here -------------------------------------------------------------------
export const fetchModuleList = async (params) => {
  try {
    const response = await api.get("/getModules", { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching module list:", error);
    throw error;
  }
};

export const fetchParentModule = async () => {
  try {
    const response = await api.get("/parentModuleDropdown");
    return response.data;
  } catch (error) {
    console.error("Error fetching parent module list:", error);
    throw error;
  }
};

export const fetchModule = async () => {
  try {
    const response = await api.get("/moduleDropdown");
    return response.data;
  } catch (error) {
    console.error("Error fetching module list:", error);
    throw error;
  }
};

export const createModule = async (formData) => {
  try {
    const response = await api.post("/createModules", formData, {
      headers: {
        // "Content-Type": "multipart/form-data",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error(
      "Error creating module:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const updateModuleStatus = async (params) => {
  try {
    const queryString = new URLSearchParams(params);
    const response = await api.put(`/toggleModule?${queryString}`);
    return response.data;
  } catch (error) {
    console.error("Error updating module status:", error);
    throw error;
  }
};

export const updateModule = async (params, data) => {
  try {
    const queryString = new URLSearchParams(params);
    const response = await api.put(`/updateModules?${queryString}`, data, {
      headers: {
        // "Content-Type": "multipart/form-data",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error updating module:", error);
    throw error;
  }
};

//--------------------------------------------Module ends here -------------------------------------------------------------------
//--------------------------------------------package begins here ----------------------------------------------------------------

export const fetchPackageList = async (params) => {
  try {
    const response = await api.get("/superAdmin/getPackages", { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching package list:", error);
    throw error;
  }
};

export const createPackage = async (data) => {
  try {
    const response = await api.post("/superAdmin/createPackage", data);
    return response.data;
  } catch (error) {
    console.error("Error creating package:", error);
    throw error;
  }
};

export const updatePackage = async (params, data) => {
  try {
    const queryString = new URLSearchParams(params);
    const response = await api.put(
      `/superAdmin/updatePackage?${queryString}`,
      data
    );
    return response.data;
  } catch (error) {
    console.error("Error updating package:", error);
    throw error;
  }
};

export const updatePackageStatus = async (params) => {
  try {
    const queryString = new URLSearchParams(params);
    const response = await api.put(
      `/superAdmin/togglePackageStatus?${queryString}`
    );
    return response.data;
  } catch (error) {
    console.error("Error updating package status:", error);
    throw error;
  }
};
//--------------------------------------------package ends here -------------------------------------------------------------------
//--------------------------------------------Stock GRN  begins here -------------------------------------------------------------------

export const fetchStockGRNTemplate = async () => {
  try {
    const response = await api.get("/inventory/template", {
      responseType: "blob",
    });
    return response;
  } catch (error) {
    console.error("Error fetching stock GRN template:", error);
    throw error;
  }
};

export const fetchModelTemplate = async () => {
  try {
    const response = await api.get("/model/template/download", {
      responseType: "blob",
    });
    return response;
  } catch (error) {
    console.error("Error fetching model template:", error);
    throw error;
  }
};

export const uploadStockGRN = async (body) => {
  try {
    const response = await api.post("/inventory/import", body, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error) {
    console.error("Error uploading stock GRN:", error);
    throw error;
  }
};

export const downloadStockGRNReference = async () => {
  try {
    const response = await api.get("/inventory/export", {
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Error downloading stock GRN reference:", error);
    throw error;
  }
};

//--------------------------------------------Stock GRN  ends here -------------------------------------------------------------------
//--------------------------------------------Jobsheet search begins here -------------------------------------------------------------------

export const fetchJobsheetSearchList = async (params) => {
  try {
    const response = await api.get("/job/searchJobSheets", { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching jobsheet search:", error);
    throw error;
  }
};

export const exportJobsheetSearchList = async (params) => {
  try {
    const response = await api.get("/job/searchJobSheets/export", { params });
    return response.data;
  } catch (error) {
    console.error("Error exporting jobsheet search:", error);
    throw error;
  }
};

//--------------------------------------------Jobsheet search ends here -------------------------------------------------------------------
//--------------------------------------------Job report begins here -------------------------------------------------------------------

export const fetchJobReport = async (params) => {
  try {
    const response = await api.get("/jobs/job-report", { params });
    return response;
  } catch (error) {
    console.error("Error fetching job report:", error);
    throw error;
  }
};

//--------------------------------------------Job report ends here -------------------------------------------------------------------
//--------------------------------------------Stock in hand report begins here -------------------------------------------------------------------

export const fetchStockInhandReport = async (params) => {
  try {
    const response = await api.get("/inventory/stock-in-hand", { params });
    return response;
  } catch (error) {
    console.error("Error fetching stock inhand report:", error);
    throw error;
  }
};

export const exportStockInHandReport = async (params) => {
  try {
    const response = await api.get("/export-stock-in-hand", { params });
    return response.data;
  } catch (error) {
    console.error("Error exporting stock in hand report:", error);
    throw error;
  }
};

//--------------------------------------------Stock in hand report ends here -------------------------------------------------------------------

//--------------------------------------------Client Dashbaord begins here -------------------------------------------------------------------

export const fetchClientStats = async () => {
  try {
    const response = await api.get("/reports/brandwise-job-stats");
    return response;
  } catch (error) {
    console.error("Error fetching open call list:", error);
    throw error;
  }
};

export const fetchBrandStats = async () => {
  try {
    const response = await api.get("/reports/brandwise-monthly-stats");
    return response;
  } catch (error) {
    console.error("Error fetching brand stats:", error);
    throw error;
  }
};

//--------------------------------------------Client Dashbaord ends here -------------------------------------------------------------------
//--------------------------------------------Service Dashbaord begins here -------------------------------------------------------------------

export const fetchServiceDashboardStats = async (params) => {
  try {
    const response = await api.get("/service-dashboard/stats", { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching service dashboard stats:", error);
    throw error;
  }
};

export const fetchServiceDashboardBrandStats = async (params) => {
  try {
    const response = await api.get("/service-dashboard/brand-stats", { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching service dashboard brand stats:", error);
    throw error;
  }
};

//--------------------------------------------Service Dashbaord ends here -------------------------------------------------------------------

//--------------------------------------------Engineer Part Consumption begins here -------------------------------------------------------------------
export const fetchEngineerPartConsumption = async (params) => {
  try {
    const response = await api.get("/reports/engineer-part-consumption", {
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching engineer part consumption:", error);
    throw error;
  }
};

export const exportEngineerPartConsumption = async (params) => {
  try {
    const response = await api.get("/export-engineer-part-consumption", {
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Error exporting engineer part consumption:", error);
    throw error;
  }
};

export const fetchPartDetails = async (params) => {
  try {
    const response = await api.get("/spare-part/dropdown", { params });
    return response;
  } catch (error) {
    console.error("Error fetching part details:", error);
    throw error;
  }
};
//--------------------------------------------Engineer Part Consumption ends here -------------------------------------------------------------------
//--------------------------------------------Stock Transfer begins here -------------------------------------------------------------------

export const transferPartList = async (params) => {
  try {
    const response = await api.get("/inventory/parts-details", { params });
    return response;
  } catch (error) {
    console.error("Error fetching transfer part list:", error);
    throw error;
  }
};

export const transferPartAllocation = async (body) => {
  try {
    const response = await api.post("/inventory/stock-transfer", body);
    return response;
  } catch (error) {
    console.error("Error fetching transfer part allocation:", error);
    throw error;
  }
};

export const importBufferStock = async (formData) => {
  try {
    const response = await api.post("/inventory/stock-transfer/import", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error importing buffer stock API:", error);
    throw error;
  }
};

export const checkPartSerialNo = async (params) => {
  try {
    const response = await api.get("/inventory/check-serial-number", {
      params,
    });
    return response;
  } catch (error) {
    console.error("Error checking part serial no:", error);
    throw error;
  }
};
//--------------------------------------------Stock Transfer ends here -------------------------------------------------------------------
//--------------------------------------------Inventory Dashboard begins here -------------------------------------------------------------------

export const fetchRegionList = async (params) => {
  try {
    const response = await api.get("/inventory/state-stock", { params });
    return response;
  } catch (error) {
    console.error("Error fetching region list:", error);
    throw error;
  }
};

export const fetchEngineerWiseList = async (params) => {
  try {
    const response = await api.get("/inventory/engineer-stock", { params });
    return response;
  } catch (error) {
    console.error("Error fetching zone list:", error);
    throw error;
  }
};

export const fetchServiceCenterList = async (params) => {
  try {
    const response = await api.get("/inventory/service-center-stock", {
      params,
    });
    return response;
  } catch (error) {
    console.error("Error fetching service center list:", error);
    throw error;
  }
};

//--------------------------------------------Inventory Dashboard ends here -------------------------------------------------------------------
//--------------------------------------------Job sheet view begins here -------------------------------------------------------------------
export const fetchJobsheetView = async (jobID) => {
  try {
    const response = await api.get(`/job/view/${jobID}`);
    return response;
  } catch (error) {
    console.error("Error fetching jobsheet view:", error);
    throw error;
  }
};
//--------------------------------------------Job sheet view ends here -------------------------------------------------------------------
//--------------------------------------------Image uplod begins here -------------------------------------------------------------------

export const singleImageUpload = async (formData) => {
  try {
    const response = await api.post("/upload-single-image", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error) {
    console.log("Error in uploading image", error);
  }
};

export const moduleImageUpload = async (formData) => {
  try {
    const response = await api.post("/upload-module-image", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error) {
    console.log("Error in uploading module image", error);
  }
};


export const multiImageUpload = async (formData) => {
  try {
    const response = await api.post("/upload-multiple-images", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error) {
    console.log("Error in uploading multiple image", error);
  }
};

export const splitImageUpload = async (formData) => {
  try {
    const response = await api.post("/upload-split-images", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error) {
    console.log("Error in uploading split image", error);
  }
};

//--------------------------------------------Image uplod ends here -------------------------------------------------------------------
//-------------------------------------------- log complaint begins here -------------------------------------------------------------------

export const fetchServiceCenterDetails = async (params) => {
  try {
    const response = await api.get("/getServiceCentreDetails", { params });
    return response;
  } catch (error) {
    console.error("Error fetching service center details:", error);
    throw error;
  }
};
//-------------------------------------------- log complaint ends here -------------------------------------------------------------------
export default api;
